
import { css } from 'lit';
export default css`
.pc-alert{
  display:flex;
  column-gap:var(--spacing-3);
  padding:var(--spacing-3) var(--spacing-4);
  color:var(--primary-eggplant);
  background-color:var(--neutral-light);
  border-radius:var(--spacing-3);
}
`;